"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisuallyCompellingNarratives() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const images = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/creative_branding_narrative.png",
    caption: "Creative Branding Excellence",
    delay: "0ms",
    ref: ref1,
    isVisible: isVisible1
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/marketing_strategy_visual.png",
    caption: "Strategic Marketing Vision",
    delay: "150ms",
    ref: ref2,
    isVisible: isVisible2
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/digital_transformation_story.png",
    caption: "Digital Transformation Stories",
    delay: "300ms",
    ref: ref3,
    isVisible: isVisible3
  }];
  return <section className="bg-light-background py-24 px-6">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-4xl font-bold text-foreground-light text-center mb-16">
          Visually Compelling Narratives
        </h2>

        <div className="grid gap-12 md:grid-cols-3">
          {images.map((image, i) => <div key={i} data-index={i} ref={image.ref} style={{
          animationDelay: image.delay
        }} className={`group relative transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${image.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="relative overflow-hidden rounded-lg shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2">
                <div className="relative h-96 w-full bg-muted-light-background transition-transform duration-[var(--duration-slow)] ease-[var(--ease-spring)] group-hover:rotate-1" style={{
              transform: "rotate(-1deg)"
            }}>
                  <img src={image.src} alt={image.caption} className="h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-background/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                  <p className="font-display text-xl font-semibold text-foreground-dark">
                    {image.caption}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}